// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__1n26p","content":"Header_content__4ZFQK","border":"Header_border__ffk8c"};